module.exports = __webpack_public_path__ + "img/rehab_lifestyle.cfdd78af.svg";